import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'rba_admin_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function login(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data.token;
}

export async function verifyToken() {
  const t = getToken();
  if (!t) return false;
  try {
    await api.get('/admin/verify');
    return true;
  } catch {
    clearToken();
    return false;
  }
}

export async function listProjects() {
  const { data } = await axios.get(`${API}/portfolio`);
  // The API returns image_url that is relative (/api/portfolio/{id}/image). Convert to absolute.
  return data.map((p) => ({ ...p, image_url: `${BACKEND_URL}${p.image_url}` }));
}

export async function createProject({ title, subtitle, file }) {
  const fd = new FormData();
  fd.append('title', title);
  fd.append('subtitle', subtitle || '');
  fd.append('image', file);
  const { data } = await api.post('/portfolio', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return { ...data, image_url: `${BACKEND_URL}${data.image_url}` };
}

export async function updateProject(id, body) {
  const { data } = await api.patch(`/portfolio/${id}`, body);
  return { ...data, image_url: `${BACKEND_URL}${data.image_url}` };
}

export async function deleteProject(id) {
  await api.delete(`/portfolio/${id}`);
}
